"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraggableItemStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _withFocusClassName = require("../../../util/withFocusClassName");
const getCursor = props => {
  if (props.isDisabled) {
    return "not-allowed";
  }
  if (props.isDragging) {
    return "grabbing";
  }
  return "pointer";
};
const DraggableItemStyled = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("div")`
    min-height: 20px;
    margin: 0;
    padding: 0;
    padding-right: ${_designTokens.space.space45};
    padding-top: ${_designTokens.space.space20};
    padding-bottom: ${_designTokens.space.space20};
    user-select: none;

    display: flex;
    align-items: center;

    background-color: ${_ref => {
  let {
    isHovered,
    isActive,
    isDragging
  } = _ref;
  return isHovered && !isActive && !isDragging ? (0, _designTokensReact.color)("color--background--neutral--weakest") : "inherit";
}};

    cursor: ${getCursor};

    box-shadow: ${_ref2 => {
  let {
    isDragging
  } = _ref2;
  return isDragging ? (0, _designTokensReact.color)("elevation--high") : "none";
}};

    ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return (0, _createFocusRingStyles.createFocusRingStyles)({
    componentBorderWidth: 0,
    componentRadius: 0,
    gap: 0,
    theme: themeMode
  });
}};
`);
exports.DraggableItemStyled = DraggableItemStyled;
DraggableItemStyled.displayName = "DraggableItemStyled";
//# sourceMappingURL=DraggableItemStyled.js.map